import { AutocompleteInput } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { WalletCards } from "lucide-react";
import {
  DateInput,
  Edit,
  NumberInput,
  ReferenceInput,
  SimpleForm,
} from "../../common";

export const SalaryStructureEdit = () => (
  <Edit title="Edit Salary Structure" actions={false}>
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <WalletCards className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Edit Salary Structure</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ReferenceInput source="employee_id" reference="employees">
              <AutocompleteInput label="Employee" optionText="name" />
            </ReferenceInput>
            <ReferenceInput source="component_id" reference="hr_payroll_components">
              <AutocompleteInput label="Component" optionText="name" />
            </ReferenceInput>
            <NumberInput source="amount" label="Amount / Percentage" />
            <DateInput source="effective_from" label="Effective From" />
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Edit>
);
